import {AccountOrganizzazione, ModalitaModificaQuantita} from '../_models/AccountOrganizzazione';

/**
 * Combinazione di preferenze in cui l'operatore non può modificare le quantità della schermata
 * operatore prima di una pausa o di una fine (feature 150, analysis A2): campo quantità Fisso,
 * «Visualizza bottoni +/- quantità» spento, e almeno una tra «Chiedi conferma pausa» e «Chiedi
 * quantità con FINE» spenta. In quei casi pausa e fine inviano le quantità senza aprire il modale.
 * Serve solo a mostrare un avviso nella card di configurazione: non blocca il salvataggio.
 */
export function isQuantitaFissaSenzaConferme(account: AccountOrganizzazione | null | undefined): boolean {
  if (account?.tipoModificaQuantita !== ModalitaModificaQuantita.Fisso || account.activeQtaPlusMinusBtn) {
    return false;
  }
  return !account.activeQtaPausa || !account.activeQtaFine;
}
